module.exports = __webpack_public_path__ + "img/dots-halftone2-2-wide_opacity3.258066d8.svg";